import { IUserInfo } from 'globalCommon/services/getUserInfo';
import getSiteHost from 'globalCommon/services/getSiteHost';
import { getDeviceLinkRules, resolveDeviceUrl } from './deviceUrl';

/**
 * 官网通用跳转链接（注册 / 登录 / 首页）与登录态规则入口。
 *
 * - 页面 HTML 里的注册 / 登录 href 只写 www 下的 PC 路由（/auth/*），不要再写 m 端路由，
 *   也不要在页面脚本里按登录态去隐藏按钮、改链接；m 域名访问 /auth/* 时由 node 重定向
 * - 联系销售按站点分流在构建期完成：HTML 里写 href="<!-- @echo CONTACT_SALES_URL -->"，
 *   取值见 .build/webpack.util.js 的 getContactSalesUrl，不要写死 /cms/contact-sales
 * - 登录态只有运行时才知道：commonPageService 初始化时调用 applyCommonLinks，
 *   已登录用户的注册 / 登录链接改为首页 '/'，由后端按 host 和端重定向到 /index 或 /main
 * - 0 跳：umu_node 下发了设备链接规则（pageData.config.deviceLinkRules）时，页面上所有站内链接
 *   按访问设备改写为 www./m. 的最终地址，见 ./deviceUrl.ts
 */
export const COMMON_LINKS = {
    HOME: '/',
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
};

export function resolveLink(href: string, userInfo?: IUserInfo): string {
    if (!href || !userInfo?.umu_id) {
        return href;
    }
    let url: URL;
    try {
        url = new URL(href, window.location.origin);
    } catch (e) {
        return href;
    }
    if (url.origin !== window.location.origin) {
        return href;
    }
    if (url.pathname === COMMON_LINKS.REGISTER || url.pathname === COMMON_LINKS.LOGIN) {
        return (/^https?:\/\//i.test(href) ? url.origin : '') + COMMON_LINKS.HOME;
    }
    return href;
}

export function applyCommonLinks(userInfo?: IUserInfo) {
    const deviceLinkRules = getDeviceLinkRules();
    if (!userInfo?.umu_id && !deviceLinkRules) {
        return;
    }
    const siteHost = getSiteHost();
    const anchors = document.querySelectorAll('a[href]');
    for (let i = 0, len = anchors.length; i < len; i++) {
        const anchor = anchors[i];
        const raw = anchor.getAttribute('href') || '';
        const loginResolved = resolveLink(raw, userInfo);
        const next = resolveDeviceUrl(loginResolved, siteHost, deviceLinkRules) ?? loginResolved;
        if (next !== raw) {
            anchor.setAttribute('href', next);
        }
    }
}
